<script setup>
defineProps({
  list: {
    type: Object,
    required: true
  }
})
</script>

<template>
  <div class="spotlist">
    <ul class="block">
      <li
        v-for="data in list"
        :key="data.id"
      >
        <NuxtLink
          :to="data.link"
          class="link"
        >
          {{ data.name }}
        </NuxtLink>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.spotlist {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 300px;
  overflow-y: scroll;
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-track {
    background: #EEF1F8;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #438FEC;
  }
  .block {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px;
    border-radius: 6px;
    background-color: #eef1f8;
  }
  .link {
    display: flex;
    padding: 7px 10px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0 2px 4px #00000026;
    color: #303030;
    font-size: 13px;
    font-weight: 700;
    line-height: 13px;
    @media (any-hover: hover) {
      transition: box-shadow 0.2s ease-in-out;
      &:hover {
        box-shadow: 0 2px 6px #00000073;
      }
    }
  }
}
</style>
